import styled, { css } from "styled-components";

const BonusesWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

const BonusesContent = styled.div`
	display: flex;
	padding: 10px;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	border-radius: 20px;
	background: linear-gradient(180deg, #262338 0%, rgba(5, 5, 18, 0) 100%);

	@media (min-width: 1024px) {
		padding: 10px 20px;
	}
`;

const BonusesHeader = styled.div`
	display: flex;
	margin: 20px 0;
`;

const BonusesHeaderTabs = styled.div`
	display: flex;
	gap: 10px;
	overflow-x: auto;
`;

const BonusesHeaderTab = styled.div`
	display: flex;
	height: 40px;
	max-width: 360px;
	padding: 0 15px;
	justify-content: center;
	align-items: center;
	gap: 5px;
	border-radius: 25px;
	color: #eff0f6;
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
	min-width: max-content;
	cursor: pointer;
	background: #120507;

	${({ active }) =>
		active &&
		css`
			background: var(--modal-input-bg);
		`}

	&:last-of-type {
		margin-right: 20px;
	}
`;

const BonusWrapper = styled.div`
	display: flex;
	flex-direction: column;
	column-gap: 10px;
	row-gap: 0;
	justify-content: center;

	@media (min-width: 768px) {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		grid-template-rows: repeat(auto, 1fr);
		column-gap: 10px;
		width: 100%;
	}
`;

export {
	BonusWrapper,
	BonusesContent,
	BonusesHeader,
	BonusesHeaderTab,
	BonusesHeaderTabs,
	BonusesWrapper,
};
